import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import ViewConfigIcon from '@mui/icons-material/ViewComfy';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import { ChevronLeft as ChevronLeftIcon } from '../../../icons/chevron-left';
import { ChevronRight as ChevronRightIcon } from '../../../icons/chevron-right';
import { Plus as PlusIcon } from '../../../icons/plus';

const viewOptions = [
  {
    icon: ViewConfigIcon,
    label: 'Mes',
    value: 'dayGridMonth'
  },
  {
    icon: ViewWeekIcon,
    label: 'Semana',
    value: 'timeGridWeek'
  },
  {
    icon: ViewDayIcon,
    label: 'Día',
    value: 'timeGridDay'
  },
  {
    icon: ViewAgendaIcon,
    label: 'Agenda',
    value: 'listWeek'
  }
];

export const CalendarToolbar = (props) => {
  const {
    date,
    mobile,
    onAddClick,
    onDateNext,
    onDatePrev,
    onDateToday,
    onViewChange,
    view,
    ...other
  } = props;

  const handleViewChange = (event) => {
    onViewChange?.(event.target.value);
  };

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        px: 3,
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      }}
      {...other}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          mb: {
            xs: 2,
            md: 0
          },
          mr: 2
        }}
      >
        <Typography variant="h5">
          {
            // Mostrar el mes en español
            format(date, 'LLLL') === 'January' ? 'Enero' : format(date, 'LLLL') === 'February' ? 'Febrero' : format(date, 'LLLL') === 'March' ? 'Marzo' : format(date, 'LLLL') === 'April' ? 'Abril' : format(date, 'LLLL') === 'May' ? 'Mayo' : format(date, 'LLLL') === 'June' ? 'Junio' : format(date, 'LLLL') === 'July' ? 'Julio' : format(date, 'LLLL') === 'August' ? 'Agosto' : format(date, 'LLLL') === 'September' ? 'Septiembre' : format(date, 'LLLL') === 'October' ? 'Octubre' : format(date, 'LLLL') === 'November' ? 'Noviembre' : format(date, 'LLLL') === 'December' ? 'Diciembre' : format(date, 'LLLL')
          }
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            ml: 1
          }}
          variant="h5"
        >
          {format(date, 'y')}
        </Typography>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          flexWrap: 'wrap',
          display: 'flex',
          m: -1
        }}
      >
        <Box sx={{ m: 1 }}>
          <IconButton onClick={onDatePrev}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton onClick={onDateNext}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>
        <TextField
          label="Vista"
          name="view"
          onChange={handleViewChange}
          select
          size="small"
          value={view}
          sx={{
            ml: {
              xs: 'auto',
              md: 1
            },
            m: 1,
            minWidth: 120
          }}
          SelectProps={{ native: true }}
        >
          {viewOptions.map((viewOption) => {
            // On mobile allow only timeGridDay and agenda views
            if (mobile && !['timeGridDay', 'listWeek'].includes(viewOption.value)) {
              return null;
            }

            return (
              <option
                key={viewOption.value}
                value={viewOption.value}
              >
                {viewOption.label}
              </option>
            );
          })}
        </TextField>
        <Button
          onClick={onAddClick}
          startIcon={<PlusIcon fontSize="small" />}
          sx={{
            m: 1,
            order: {
              xs: -1,
              md: 0
            },
            width: {
              xs: '100%',
              md: 'auto'
            }
          }}
          variant="contained"
        >
          Agregar evento
        </Button>
      </Box>
    </Box>
  );
};

CalendarToolbar.propTypes = {
  children: PropTypes.node,
  date: PropTypes.instanceOf(Date).isRequired,
  mobile: PropTypes.bool,
  onAddClick: PropTypes.func,
  onDateNext: PropTypes.func,
  onDatePrev: PropTypes.func,
  onDateToday: PropTypes.func,
  onViewChange: PropTypes.func,
  view: PropTypes.oneOf([
    'dayGridMonth',
    'timeGridWeek',
    'timeGridDay',
    'listWeek'
  ]).isRequired
};
